"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IPAPER_SCRIPT_URL = exports.IPAPER_SCRIPT_ID = exports.IPAPER_ROOT_ID = exports.IPAPER_IFRAME_ID = exports.FEATURE_REMOVE_PERMANENT_MINIBAG_FROM_CATALOGUE = void 0;
const IPAPER_SCRIPT_URL = exports.IPAPER_SCRIPT_URL = 'https://cdn.ipaper.io/flipbooks/api/v3/latest.js';
const IPAPER_SCRIPT_ID = exports.IPAPER_SCRIPT_ID = 'ipaper-script';
const IPAPER_IFRAME_ID = exports.IPAPER_IFRAME_ID = 'ipaper-catalogue';
const IPAPER_ROOT_ID = exports.IPAPER_ROOT_ID = 'catalogue-ipaper-root';
/** "When enabled, the permanent minibag will be removed from the catalogue. And will be shown only on hover of the basket icon in the top-area"; */ const FEATURE_REMOVE_PERMANENT_MINIBAG_FROM_CATALOGUE = exports.FEATURE_REMOVE_PERMANENT_MINIBAG_FROM_CATALOGUE = 'B97055D2-F4B9-41B0-B18C-B867983AE043';
